var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiBoxFrameOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 665.854,
    height: 345.088,
    viewBox: "0 0 665.854 345.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Box_frame_outline",
    transform: "translate(-349 -219.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_921",
    "data-name": "Tracciato 921",
    d: "M4.459,41.216l1.36,250.426,8.488,33.466,37.56,1.029,151.165,1.491,442.916,5.989,4.207-17.306,9.977-268.63-.714-25.337L629.344,9.439,33.626.332,0,0Z",
    transform: "matrix(1, -0.017, 0.017, 1, 349, 230.986)",
    fill: "#fffdf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1172",
    "data-name": "Tracciato 1172",
    d: "M-7.5,51.347l5.431,211.9,3.749,38.073L33.9,302.5l139.125,1.817,444.42,7.763.408-18.129,1.688-96.731,3.915-173.837L598.579,12.4,15.828,2.269-9.451-.124Z",
    transform: "matrix(1, -0.017, 0.017, 1, 371.27, 240.725)",
    fill: "none",
    stroke: "#c78b43",
    strokeWidth: 3,
    opacity: 0.98
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiBoxFrameOutline);
export default __webpack_public_path__ + "static/media/UI_Box_frame_outline.38d1c3e6ec47c22569118040718aca9b.svg";
export { ForwardRef as ReactComponent };